var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Router } from '@angular/router';
import { BookedTrip, PassengerFlightInfo } from '@ibe/models';
import { getBrandFeatures } from '@ibe/models/ui';
import { TAPDataStorageService } from '@ibe/services/mocks.tap';
import { Store } from '@ngrx/store';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as moment from 'moment';
import { environment } from '@environments/environment';
moment.locale(environment.locale);
var BookedTripEffect = /** @class */ (function () {
    function BookedTripEffect(store, router, storage) {
        this.store = store;
        this.router = router;
        this.storage = storage;
        this.storage.initializeBookingsIfEmpty();
    }
    /**
     * Effect that gets a BookedTrip by it's pnr
     *
     * @param {string} pnr
     * @memberof BookedTripEffect
     */
    BookedTripEffect.prototype.getBookedTipByPNR = function (pnr) {
        var _this = this;
        this.store.dispatch(new BookedTripActions.LoadingAction);
        this.storage.observableBookings.subscribe(function (value) { }, function (err) { }, function () {
            var bookedTrip = _this.storage.getBookedTrip(pnr);
            if (bookedTrip) {
                _this.store.dispatch(new BookedTripActions.PutBookedTripAction(bookedTrip));
            }
            else {
                _this.router.navigate(['/my-bookings/not-found']);
            }
        });
    };
    /**
     * Effect that updates a BookedTrip
     *
     * @param {string} pnr
     * @param {BookedTrip} updatedBookedTrip
     * @memberof BookedTripEffect
     */
    BookedTripEffect.prototype.updateBookedTrip = function (pnr, updatedBookedTrip) {
        this.store.dispatch(new BookedTripActions.LoadingAction);
        this.storage.updateBooking(pnr, updatedBookedTrip);
        // after update success  dispatch updated bookedtrip to the store
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(updatedBookedTrip));
    };
    BookedTripEffect.prototype.createStopoverDataHotel = function (booked_trip, city) {
        if (city === void 0) { city = ''; }
        var stopoverData = {
            location: null,
            days: null,
            checkin: null,
            checkout: null,
            passengers: {
                adults: null,
                children: null,
                rooms: null
            }
        };
        stopoverData.passengers = {
            adults: booked_trip.passengers.adults + booked_trip.passengers.youngAdults,
            children: booked_trip.passengers.children + booked_trip.passengers.infants,
            rooms: 1
        };
        for (var key in booked_trip.flights) {
            var value = booked_trip.flights[key];
            if (value.is_stopover) {
                if (city) {
                    if (value.stopover.airport.location.city === city) {
                        stopoverData.location = __assign({}, value.stopover.airport.location);
                        stopoverData.days = value.stopover.days;
                        stopoverData.checkin = value.arrival.time;
                        stopoverData.checkout = moment(value.arrival.time).add(value.stopover.days, 'days').toDate();
                        break;
                    }
                }
                else {
                    stopoverData.location = __assign({}, value.stopover.airport.location);
                    stopoverData.days = value.stopover.days;
                    stopoverData.checkin = value.arrival.time;
                    stopoverData.checkout = moment(value.arrival.time).add(value.stopover.days, 'days').toDate();
                }
            }
            else {
                if (value.arrival.airport.location.city === city) {
                    stopoverData.location = value.arrival.airport.location;
                    stopoverData.checkin = value.arrival.time;
                    stopoverData.days = 1;
                    stopoverData.checkout = moment(value.arrival.time).add(1, 'days').toDate();
                }
            }
        }
        return stopoverData;
    };
    BookedTripEffect.prototype.createTotalSummary = function (booked_trip) {
        var filterFnSum = function (passengerInfo, item) {
            var stops = passengerInfo.stops.filter(function (accPass) { return accPass.added && accPass.added[item]; });
            return stops.reduce(function (accPass, pass) { return accPass += pass.added[item].price; }, 0);
        };
        var filterFnCount = function (passengerInfo, item) {
            var stops = passengerInfo.stops.filter(function (accPass) { return accPass.added && accPass.added[item]; });
            return stops.reduce(function (accPass, pass) { return accPass += 1; }, 0);
        };
        var filterFnSumFn = function (passengerInfo, item) {
            var stops = passengerInfo.stops.filter(function (accPass) { return accPass.added && accPass.added[item]; });
            return stops.reduce(function (accPass, pass) { return accPass += pass.added[item].reduce(function (acc, cur) { return acc += cur.price; }, 0); }, 0);
        };
        var filterFnCountFn = function (passengerInfo, item) {
            var stops = passengerInfo.stops.filter(function (accPass) { return accPass.added && accPass.added[item]; });
            return stops.reduce(function (accPass, pass) { return accPass += pass.added[item].reduce(function (acc, cur) { return acc += 1; }, 0); }, 0);
        };
        var summaryFlights = booked_trip.flights.reduce(function (accFlight, flight) {
            var summary = [];
            var brand = getBrandFeatures(flight.options.brand);
            /**
             * Tickets
             */
            summary.push({ item: 'tickets', label: 'Flights', total: flight.passengerInfo.length, value: (flight.passengerInfo.length * flight.options.price).toFixed(2), sort: 10 });
            /**
             * Seats
             */
            var seatsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSum(cur, 'boughtSeat'); }, 0);
            var seatsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCount(cur, 'boughtSeat'); }, 0);
            if (seatsSum)
                summary.push({ item: 'seats', total: seatsCount, label: 'Seats', value: seatsSum.toFixed(2), sort: 20 });
            /**
             * Extra bags
             */
            var extraBagsSum = flight.passengerInfo.reduce(function (accPass, pass) {
                return accPass += pass.stops
                    .filter(function (cur) { return cur.added && cur.added.added_bags; })
                    .reduce(function (accStop, stop) { return accStop += stop.added.added_bags.reduce(function (accBags, bag) { return accBags += bag; }, 0); }, 0);
            }, 0);
            var extraBagsCount = flight.passengerInfo.reduce(function (accPass, pass) { return accPass += pass.stops.filter(function (cur) { return cur.added && cur.added.added_bags; }).reduce(function (accStop, stop) { return accStop += stop.added.added_bags.length; }, 0); }, 0);
            if (extraBagsSum)
                summary.push({ item: 'extra-bags', total: extraBagsCount, label: 'Extra Bags', value: extraBagsSum.toFixed(2), sort: 30 });
            /**
             * Fast track
             */
            var brandsFasttrack = brand.filter(function (cur) { return cur.type == 'extra'; }).find(function (cur) { return cur.id == 'fasttrack'; });
            var priceFasttrack = brandsFasttrack && brandsFasttrack.price ? brandsFasttrack.price : 0;
            var sumPassengerWithFastTrack = flight.passengerInfo.reduce(function (accPass, pass) { return accPass += pass.stops.filter(function (cur) { return cur.added && cur.added.fastTrackEnabled; }).length; }, 0);
            var fastTrackSum = sumPassengerWithFastTrack * priceFasttrack;
            if (fastTrackSum)
                summary.push({ item: 'fasttrack', total: sumPassengerWithFastTrack, label: 'Fast Track', value: fastTrackSum.toFixed(2), sort: 40 });
            /**
             * Lounge
             */
            var brandsLounge = getBrandFeatures(flight.options.brand).filter(function (cur) { return cur.type == 'extra'; }).find(function (cur) { return cur.id == 'lounge'; });
            var priceLounge = brandsLounge && brandsLounge.price ? brandsLounge.price : 0;
            var sumPassenge = flight.passengerInfo.reduce(function (accPass, pass) { return accPass += pass.stops.filter(function (cur) { return cur.added && cur.added.loungeEnabled; }).length; }, 0);
            var loungeSum = sumPassenge * priceLounge;
            if (loungeSum)
                summary.push({ item: 'lounge', total: sumPassenge, label: 'Lounge', value: loungeSum.toFixed(2), sort: 50 });
            /**
             * Sports Equipments
             */
            var sportEquipmentsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSumFn(cur, 'sportsEquipment'); }, 0);
            var sportEquipmentsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCountFn(cur, 'sportsEquipment'); }, 0);
            if (sportEquipmentsSum)
                summary.push({ item: 'sport-equipments', total: sportEquipmentsCount, label: 'Sport Equipments', value: sportEquipmentsSum.toFixed(2), sort: 60 });
            /**
             * Music Instruments
             */
            var musicInstrumentsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSumFn(cur, 'musicInstruments'); }, 0);
            var musicInstrumentsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCountFn(cur, 'musicInstruments'); }, 0);
            if (musicInstrumentsSum)
                summary.push({ item: 'music-instruments', total: musicInstrumentsCount, label: 'Music Instruments', value: musicInstrumentsSum.toFixed(2), sort: 70 });
            /**
             * Pets
             */
            var petsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSumFn(cur, 'pets'); }, 0);
            var petsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCountFn(cur, 'pets'); }, 0);
            if (petsSum)
                summary.push({ item: 'pets', label: 'Pets', total: petsCount, value: petsSum.toFixed(2), sort: 80 });
            /**
             * Special Meals
             */
            var mealsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSum(cur, 'specialMeals'); }, 0);
            var mealsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCount(cur, 'specialMeals'); }, 0);
            var mealsAdded = flight.passengerInfo.reduce(function (accPass, passenger) { return accPass += passenger.stops.filter(function (stop) { return stop.added && stop.added.specialMeals; }).length; }, 0);
            if (mealsAdded)
                summary.push({ item: 'special-meals', total: mealsCount, label: 'Special Meals', value: mealsSum.toFixed(2), sort: 90 });
            /**
             * Taxes
             */
            // const sumSummary = summary.reduce((acc, cur) => acc += parseFloat(cur.value), 0);
            // summary.push({ item: 'taxes', label: 'Taxes', total: 1, value: (sumSummary * 0.25).toFixed(2), sort: 100 });
            summary.sort(function (a, b) { return a.sort - b.sort; });
            accFlight.push({ flight: flight, summary: summary });
            return accFlight;
        }, []);
        var sumSummaryFlights = summaryFlights
            .reduce(function (acc, cur) { return acc.concat(cur.summary); }, [])
            .reduce(function (acc, cur) {
            cur.value = parseFloat(cur.value);
            cur.total = parseFloat(cur.total);
            var item = acc.find(function (c) { return c.item == cur.item; });
            if (item) {
                item.value += parseFloat(cur.value);
                item.total += parseFloat(cur.total);
            }
            else {
                acc.push(cur);
            }
            return acc;
        }, [])
            .map(function (cur) {
            cur.value = parseFloat(cur.value).toFixed(2);
            cur.total = parseFloat(cur.total).toFixed(2);
            return cur;
        });
        if (booked_trip.discounts) {
            var totalDiscount = booked_trip.discounts.reduce(function (acc, cur) { return acc += parseFloat(cur.value); }, 0);
            sumSummaryFlights.push({ item: 'discounts', label: 'Discounts', total: totalDiscount, value: -totalDiscount.toFixed(2), sort: 200 });
        }
        /**
         * Insurance
         */
        var insurance = booked_trip.insurance;
        if (insurance) {
            sumSummaryFlights.push({
                item: 'insurance', label: 'Insurance', total: booked_trip.passengerCount, value: (booked_trip.passengerCount * insurance.reduce(function (acc, cur) { return acc += cur.price; }, 0)).toFixed(2), sort: 100
            });
            sumSummaryFlights.sort(function (a, b) { return a.sort - b.sort; });
        }
        var total = sumSummaryFlights.reduce(function (acc, cur) {
            if (['discounts'].includes(cur.item)) {
                return acc -= parseFloat(cur.value);
            }
            else {
                return acc += parseFloat(cur.value);
            }
        }, 0).toFixed(2);
        var totalSummary = {
            flights: summaryFlights,
            discounts: booked_trip.discounts,
            summary: sumSummaryFlights,
            total: total
        };
        return totalSummary;
    };
    BookedTripEffect.prototype.createShoppingCart = function (booked_trip) {
        var filterFnSum = function (passengerInfo, item) {
            var stops = passengerInfo.stops.filter(function (accPass) { return accPass && accPass[item]; });
            return stops.reduce(function (accPass, pass) { return accPass += pass[item].price; }, 0);
        };
        var filterFnCount = function (passengerInfo, item) {
            var stops = passengerInfo.stops.filter(function (accPass) { return accPass && accPass[item]; });
            return stops.reduce(function (accPass, pass) { return accPass += 1; }, 0);
        };
        var filterFnSumFn = function (passengerInfo, item) {
            var stops = passengerInfo.stops.filter(function (accPass) { return accPass && accPass[item]; });
            return stops.reduce(function (accPass, pass) { return accPass += pass[item].reduce(function (acc, cur) { return acc += cur.price; }, 0); }, 0);
        };
        var filterFnCountFn = function (passengerInfo, item) {
            var stops = passengerInfo.stops.filter(function (accPass) { return accPass && accPass[item]; });
            return stops.reduce(function (accPass, pass) { return accPass += pass[item].reduce(function (acc, cur) { return acc += 1; }, 0); }, 0);
        };
        var summaryFlights = booked_trip.flights.reduce(function (accFlight, flight) {
            var summary = [];
            var brand = getBrandFeatures(flight.options.brand);
            /**
             * Tickets
             */
            summary.push({ item: 'tickets', label: 'Flights', total: flight.passengerInfo.length, value: (flight.passengerInfo.length * flight.options.price).toFixed(2), sort: 10 });
            /**
             * Seats
             */
            var seatsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSum(cur, 'boughtSeat'); }, 0);
            var seatsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCount(cur, 'boughtSeat'); }, 0);
            if (seatsSum)
                summary.push({ item: 'seats', total: seatsCount, label: 'Seats', value: seatsSum.toFixed(2), sort: 20 });
            /**
             * Extra bags
             */
            var extraBagsSum = flight.passengerInfo.reduce(function (accPass, pass) {
                return accPass += pass.stops
                    .filter(function (cur) { return cur && cur.added_bags; })
                    .reduce(function (accStop, stop) { return accStop += stop.added_bags.reduce(function (accBags, bag) { return accBags += bag; }, 0); }, 0);
            }, 0);
            var extraBagsCount = flight.passengerInfo.reduce(function (accPass, pass) { return accPass += pass.stops.filter(function (cur) { return cur && cur.added_bags; }).reduce(function (accStop, stop) { return accStop += stop.added_bags.length; }, 0); }, 0);
            if (extraBagsSum)
                summary.push({ item: 'extra-bags', total: extraBagsCount, label: 'Extra Bags', value: extraBagsSum.toFixed(2), sort: 30 });
            /**
             * Fast track
             */
            var brandsFasttrack = brand.filter(function (cur) { return cur.type == 'extra'; }).find(function (cur) { return cur.id == 'fasttrack'; });
            var priceFasttrack = brandsFasttrack && brandsFasttrack.price ? brandsFasttrack.price : 0;
            var sumPassengerWithFastTrack = flight.passengerInfo.reduce(function (accPass, pass) { return accPass += pass.stops.filter(function (cur) { return cur && cur.fastTrackEnabled; }).length; }, 0);
            var fastTrackSum = sumPassengerWithFastTrack * priceFasttrack;
            if (fastTrackSum)
                summary.push({ item: 'fasttrack', total: sumPassengerWithFastTrack, label: 'Fast Track', value: fastTrackSum.toFixed(2), sort: 40 });
            /**
             * Lounge
             */
            var brandsLounge = getBrandFeatures(flight.options.brand).filter(function (cur) { return cur.type == 'extra'; }).find(function (cur) { return cur.id == 'lounge'; });
            var priceLounge = brandsLounge && brandsLounge.price ? brandsLounge.price : 0;
            var sumPassenge = flight.passengerInfo.reduce(function (accPass, pass) { return accPass += pass.stops.filter(function (cur) { return cur && cur.loungeEnabled; }).length; }, 0);
            var loungeSum = sumPassenge * priceLounge;
            if (loungeSum)
                summary.push({ item: 'lounge', total: sumPassenge, label: 'Lounge', value: loungeSum.toFixed(2), sort: 50 });
            /**
             * Sports Equipments
             */
            var sportEquipmentsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSumFn(cur, 'sportsEquipment'); }, 0);
            var sportEquipmentsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCountFn(cur, 'sportsEquipment'); }, 0);
            if (sportEquipmentsSum)
                summary.push({ item: 'sport-equipments', total: sportEquipmentsCount, label: 'Sport Equipments', value: sportEquipmentsSum.toFixed(2), sort: 60 });
            /**
             * Music Instruments
             */
            var musicInstrumentsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSumFn(cur, 'musicInstruments'); }, 0);
            var musicInstrumentsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCountFn(cur, 'musicInstruments'); }, 0);
            if (musicInstrumentsSum)
                summary.push({ item: 'music-instruments', total: musicInstrumentsCount, label: 'Music Instruments', value: musicInstrumentsSum.toFixed(2), sort: 70 });
            /**
             * Pets
             */
            var petsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSumFn(cur, 'pets'); }, 0);
            var petsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCountFn(cur, 'pets'); }, 0);
            if (petsSum)
                summary.push({ item: 'pets', label: 'Pets', total: petsCount, value: petsSum.toFixed(2), sort: 80 });
            /**
             * Special Meals
             */
            var mealsSum = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnSum(cur, 'specialMeals'); }, 0);
            var mealsCount = flight.passengerInfo.reduce(function (accPass, cur) { return accPass += filterFnCount(cur, 'specialMeals'); }, 0);
            var mealsAdded = flight.passengerInfo.reduce(function (accPass, passenger) { return accPass += passenger.stops.filter(function (stop) { return stop && stop.specialMeals; }).length; }, 0);
            if (mealsAdded)
                summary.push({ item: 'special-meals', total: mealsCount, label: 'Special Meals', value: mealsSum.toFixed(2), sort: 90 });
            /**
             * Carbon Offset
             */
            var carbonOffset = booked_trip.carbon_offset ? 12 : 0;
            if (carbonOffset) {
                summary.push({ item: 'carbonoffset', label: 'Carbon Offsets', total: 1, value: (carbonOffset).toFixed(2), sort: 99 });
            }
            /**
             * Danish guarantee fund
             */
            var danish = booked_trip.danish_guarantee_fund ? 60 : 0;
            if (danish) {
                summary.push({ item: 'danish-guarantee-fund', label: 'Danish Guarantee Fund', total: 1, value: (danish).toFixed(2), sort: 99 });
            }
            /**
             * Taxes
             */
            // const sumSummary = summary.reduce((acc, cur) => acc += parseFloat(cur.value), 0);
            // summary.push({ item: 'taxes', label: 'Taxes', total: 1, value: (sumSummary * 0.25).toFixed(2), sort: 100 });
            summary.sort(function (a, b) { return a.sort - b.sort; });
            accFlight.push({ flight: flight, summary: summary });
            return accFlight;
        }, []);
        var sumSummaryFlights = JSON.parse(JSON.stringify(summaryFlights))
            .reduce(function (acc, cur) { return acc.concat(cur.summary); }, [])
            .reduce(function (acc, cur) {
            cur.value = parseFloat(cur.value);
            cur.total = parseFloat(cur.total);
            var item = acc.find(function (c) { return c.item == cur.item; });
            if (item) {
                item.value += parseFloat(cur.value);
                item.total += parseFloat(cur.total);
            }
            else {
                acc.push(cur);
            }
            return acc;
        }, [])
            .map(function (cur) {
            cur.value = parseFloat(cur.value).toFixed(2);
            cur.total = parseFloat(cur.total).toFixed(2);
            return cur;
        });
        if (booked_trip.discounts && booked_trip.discounts.length) {
            var totalDiscount = booked_trip.discounts.reduce(function (acc, cur) { return acc += parseFloat(cur.value); }, 0);
            sumSummaryFlights.push({ item: 'discounts', label: 'Discounts', total: totalDiscount, value: -totalDiscount.toFixed(2), sort: 200 });
        }
        /**
         * Insurance
         */
        var insurance = booked_trip.insurance;
        if (insurance) {
            sumSummaryFlights.push({
                item: 'insurance', label: 'Insurance', total: booked_trip.passengerCount, value: (booked_trip.passengerCount * insurance.reduce(function (acc, cur) { return acc += cur.price; }, 0)).toFixed(2), sort: 100
            });
            sumSummaryFlights.sort(function (a, b) { return a.sort - b.sort; });
        }
        var total = sumSummaryFlights.reduce(function (acc, cur) {
            if (['discounts'].includes(cur.item) && acc > 0) {
                return acc -= parseFloat(cur.value);
            }
            else {
                return acc += parseFloat(cur.value);
            }
        }, 0).toFixed(2);
        var totalSummary = {
            flights: summaryFlights,
            discounts: booked_trip.discounts,
            summary: sumSummaryFlights,
            total: total < 0 ? 0 : total
        };
        return totalSummary;
    };
    BookedTripEffect.prototype.addCarToBookedTrip = function (value) {
        this.store.dispatch(new BookedTripActions.PutBookedTripExtrasAction({ type: 'rent-a-car', value: value }));
    };
    return BookedTripEffect;
}());
export { BookedTripEffect };
